import React from 'react';
import { Outlet } from 'react-router-dom';
import AppShell from './AppShell';

function HomePage() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}

export default HomePage;
